import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login: false,//免登陆
    userName: "",
    paperCode: "",
    mobilePhone: "",
    areaSeq:""//地区编码
  },
  mutations: {
    loginState: function (state, val) {
      state.login = val;
    },
    userNameState: function (state, val) {
      state.userName = val;
    },
    paperCodeState: function (state, val) {
      state.paperCode = val;
    },
    mobilePhoneState: function (state, val) {
      state.mobilePhone = val;
    },
    areaSeqState: function(state,val){
      state.areaSeq = val;
    }
  },
  actions: {

  },
  getters: {
  }
})
